<template>
    <div>
        <template v-if="isBusy">
            <Preloader/>
        </template>

        <template v-else>
            <form method="POST" name="devis_panne_mecanique_standard" @submit.prevent="onSubmit">
                <div class="row">
                    <div class="col-12">
                        <div class="page__head-title page__head-title--orange">
                            <div class="page__head-title__text page__head-title__text--orange">Garantie Outils de Jardin</div>
                            <div class="page__head-title__notice">(* champs obligatoires)</div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form_ttl">Informations sur l'outil de jardin &agrave; assurer</div>
                    </div>
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Marque</div>-->
<!--                            <div class="form__item__input-wrapper">-->
<!--                                <input type="text" v-model="garantieTondeuse.marque_tondeuse" name="marque_auto"-->
<!--                                       id="marque_auto"-->
<!--                                       class="input_n"-->
<!--                                       :disabled="searchVehicleFilled"-->
<!--                                       :class="{input_red_shadow: hasError('marque_tondeuse')}"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                  <div class="col-12">
                    <div class="form__item">
                      <div class="form__item__label form__item__label--required">Type d'outil</div>
                      <div class="form__item__input-wrapper">
                        <select v-model="garantieOutilsJardin.type" name="type" id="type" class="select_n"
                                :class="{input_red_shadow: hasError('type')}"
                        >
                          <option value="0">Choisir un type d'outil...</option>
                          <option v-for="item in vehicleTypeOptions" :value="item.value">{{item.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                      <div class="form__item">
                        <div class="form__item__label form__item__label--required">Marque</div>
                        <div class="form__item__input-wrapper">
                          <select v-model="garantieOutilsJardin.marque" name="marque" id="marque" class="select_n"
                                  :class="{input_red_shadow: hasError('marque')}"
                          >
                            <option value="0">Choisir une marque...</option>
                            <option value="Autre">Autre</option>
                            <option value="BRIGGS&STRATTON">BRIGGS&STRATTON</option>
                            <option value="EINHELL">EINHELL</option>
                            <option value="GARDENA">GARDENA</option>
                            <option value="RYOBI">RYOBI</option>
                            <option value="HONDA">HONDA</option>
                            <option value="BOSCH">BOSCH</option>
                            <option value="KAWASAKI">KAWASAKI</option>
                            <option value="HILLVERT">HILLVERT</option>
                            <option value="STERWINS">STERWINS</option>
                            <option value="STIHL">STIHL</option>
                            <option value="MTD">MTD</option>
                            <option value="BLACK + DECKER">BLACK + DECKER</option>
                            <option value="MAKITA">MAKITA</option>
                            <option value="KOHLER">KOHLER</option>
                            <option value="TROYBILT">TROYBILT</option>
                            <option value="AL-KO">AL-KO</option>
                            <option value="ALPINA">ALPINA</option>
                            <option value="GREENWORKS">GREENWORKS</option>
                            <option value="SCHEPPACH">SCHEPPACH</option>
                            <option value="YARD FORCE">YARD FORCE</option>
                            <option value="FEIDER">FEIDER</option>
                            <option value="WORX">WORX</option>
                            <option value="HECHT">HECHT</option>
                            <option value="UNION">UNION</option>
                            <option value="FICHOPS">FICHOPS</option>
                            <option value="MOWOX">MOWOX</option>
                            <option value="EGO">EGO</option>
                            <option value="FUXTEC">FUXTEC</option>
                            <option value="STIGA">STIGA</option>
                            <option value="ELEM GARDEN TECHNIC">ELEM GARDEN TECHNIC</option>
                            <option value="HYUNDAI">HYUNDAI</option>
                            <option value="TEXAS">TEXAS</option>
                            <option value="VHBW">VHBW</option>
                            <option value="VITO">VITO</option>
                            <option value="X-PERFORMER">X-PERFORMER</option>
                            <option value="FP">FP</option>
                            <option value="MCCULLOCH">MCCULLOCH</option>
                            <option value="WOLF GARTEN">WOLF GARTEN</option>
                            <option value="HUSQVARNA">HUSQVARNA</option>
                            <option value="NOVARDEN">NOVARDEN</option>
                            <option value="POWERPLUS">POWERPLUS</option>
                            <option value="ROBOMOW">ROBOMOW</option>
                            <option value="EGO POWER">EGO POWER</option>
                            <option value="GOODTIRE">GOODTIRE</option>
                            <option value="HUCOCO">HUCOCO</option>
                            <option value="MITSUBISHI">MITSUBISHI</option>
                            <option value="OREGON">OREGON</option>
                            <option value="VILLAGER">VILLAGER</option>
                            <option value="FLYMO">FLYMO</option>
                            <option value="GREENCUT">GREENCUT</option>
                            <option value="KÄRCHER">KÄRCHER</option>
                            <option value="TECUMSEH">TECUMSEH</option>
                            <option value="DUNSCH">DUNSCH</option>
                            <option value="ENERGIZER">ENERGIZER</option>
                            <option value="JARDIN">JARDIN</option>
                            <option value="PAPILLON">PAPILLON</option>
                            <option value="VIGOR">VIGOR</option>
                            <option value="VONROC">VONROC</option>
                            <option value="BOUDECH">BOUDECH</option>
                            <option value="DOLMAR">DOLMAR</option>
                            <option value="GOODYEAR">GOODYEAR</option>
                            <option value="GREEN CAT">GREEN CAT</option>
                            <option value="HELIOTRADE">HELIOTRADE</option>
                            <option value="HOOKII">HOOKII</option>
                            <option value="KYOTO">KYOTO</option>
                            <option value="METABO">METABO</option>
                            <option value="RACING">RACING</option>
                            <option value="SOLO BY AL-KO">SOLO BY AL-KO</option>
                            <option value="STEINER">STEINER</option>
                            <option value="TOTAL">TOTAL</option>
                            <option value="WOLF-GARTEN">WOLF-GARTEN</option>
                            <option value="YAMAHA">YAMAHA</option>
                            <option value="ALIZENDEH">ALIZENDEH</option>
                            <option value="COSTWAY">COSTWAY</option>
                            <option value="FISKARS">FISKARS</option>
                            <option value="GARDEN FRIEND">GARDEN FRIEND</option>
                            <option value="GARDEO PRO">GARDEO PRO</option>
                            <option value="GARLAND">GARLAND</option>
                            <option value="GT ELEC">GT ELEC</option>
                            <option value="HABITAT ET JARDIN">HABITAT ET JARDIN</option>
                            <option value="JOHN DEERE">JOHN DEERE</option>
                            <option value="KOMA TOOLS">KOMA TOOLS</option>
                            <option value="KUBOTA">KUBOTA</option>
                            <option value="LANDXCAPE">LANDXCAPE</option>
                            <option value="MURRAY">MURRAY</option>
                            <option value="NEMURA">NEMURA</option>
                            <option value="OUTILS WOLF">OUTILS WOLF</option>
                            <option value="SANDRIGARDEN">SANDRIGARDEN</option>
                            <option value="SKIL">SKIL</option>
                            <option value="SNAPPER">SNAPPER</option>
                            <option value="VARO">VARO</option>
                            <option value="VIDAXL">VIDAXL</option>
                            <option value="WIESENFIELD">WIESENFIELD</option>
                            <option value="WOW">WOW</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Mod&egrave;le</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieOutilsJardin.modele_porteur" name="modele_porteur"
                                       id="modele_porteur"
                                       class="input_n"
                                       :class="{input_red_shadow: hasError('modele_porteur')}"/>
                            </div>
                        </div>
                    </div>
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Carburant</div>-->
<!--                            <div class="form__item__input-wrapper">-->
<!--                                <select v-model="garantieTondeuse.carburant" name="carburant" id="carburant" class="select_n"-->
<!--                                        :disabled="searchVehicleFilled"-->
<!--                                        :class="{input_red_shadow: hasError('carburant')}"-->
<!--                                >-->
<!--                                    <option value="0">Choisir un carburant...</option>-->
<!--                                    <option value="1">Essence</option>-->
<!--                                    <option value="2">Diesel</option>-->
<!--                                    <option value="3">GPL</option>-->
<!--                                    <option value="4">Electrique</option>-->
<!--                                    <option value="5">Hybride</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <template v-if="+garantieTondeuse.carburant === AUTO_ENGINE.ELECTRIC.ID">-->
<!--                        <div class="col-12">-->
<!--                            <div class="form__item">-->
<!--                                <div class="form__item__label form__item__label&#45;&#45;required">-->
<!--                                    Puissance en Kw-->
<!--                                </div>-->
<!--                                <div class="form__item__input-wrapper">-->
<!--                                    <select v-model="garantieTondeuse.power_kw" name="power_kw" id="puis_kw" class="select_n"-->
<!--                                            :class="{input_red_shadow: hasError('power_kw')}"-->
<!--                                    >-->
<!--                                        <option value="0">Choisir un puissance en Kw</option>-->
<!--                                        <option value="1">– de 150 Kw</option>-->
<!--                                        <option value="2">De 150 Kw à 400 Kw</option>-->
<!--                                        <option value="3">+ de 400 Kw</option>-->
<!--                                    </select>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    <template v-else>-->
<!--                        <div class="col-12">-->
<!--                            <div class="form__item">-->
<!--                                <div class="form__item__label form__item__label&#45;&#45;required">Cylindr&eacute;e</div>-->
<!--                                <div class="form__item__input-wrapper">-->
<!--                                    <select v-model="garantieTondeuse.cylindree" name="cylindree" id="cylindree"-->
<!--                                            :disabled="searchVehicleFilled"-->
<!--                                            class="select_n" :class="{input_red_shadow: hasError('cylindree')}">-->
<!--                                        <option value="0">Choisir un type de cylindr&eacute;e</option>-->
<!--                                        <option value="1">- de 2.5 L</option>-->
<!--                                        <option value="2">de 2.5 L &agrave; 3.5 L</option>-->
<!--                                        <option value="3">+ de 3.5 L</option>-->
<!--                                    </select>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">-->
<!--                                Puissance fiscale-->
<!--                            </div>-->
<!--                            <div class="form__item__input-wrapper">-->
<!--                                <input type="text" v-model="garantieTondeuse.puis_fisc" name="puis_fisc" id="puis_fisc"-->
<!--                                       :disabled="searchVehicleFilled"-->
<!--                                       class="input_n" :class="{input_red_shadow: hasError('puis_fisc')}"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Date de 1&egrave;re mise en circulation</div>-->
<!--                            <div class="form__item__input-wrapper form__item__input-wrapper&#45;&#45;date currency-datepicker">-->
<!--                                <CustomDatepicker :date.sync="circulationDateInput" :disabled="searchVehicleFilled" :has-error="hasError('jour_mise_en_circulation')"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Num&eacute;ro de s&eacute;rie</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieOutilsJardin.num_serie" name="num_serie" id="num_serie"
                                       class="input_n" :class="{input_red_shadow: hasError('num_serie')}"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                      <div class="form__item">
                        <div class="form__item__label form__item__label--required">Num&eacute;ro du ticket de caisse</div>
                        <div class="form__item__input-wrapper">
                          <input type="text" v-model="garantieOutilsJardin.num_facture" name="num_facture" id="num_facture"
                                 class="input_n" :class="{input_red_shadow: hasError('num_facture')}"/>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form__item relative">
                        <div class="form__item__label form__item__label--required">Prix de l'outil</div>
                        <div class="form__item__input-wrapper">
                          <input type="text" v-model="garantieOutilsJardin.prix" name="prix" id="prix"
                                 class="input_n" :class="{input_red_shadow: hasError('prix')}"/>
                        </div>
                        <div class="tooltip__wrap">
                          <div class="tooltip__wrap--icon"></div>

                          <div class="tooltip__wrap--text">
                            <div class="tooltip__wrap--text--notice">
                              <table border="1" style="width:250px">
                                <tr>
                                  <td><strong>Panne + casse</strong></td>
                                  <td colspan="2"><strong>Prix de vente TTC</strong></td>
                                </tr>
                                <tr>
                                  <td><strong>Valeur Matériel</strong></td>
                                  <td><strong>12 mois</strong></td>
                                  <td><strong>24 mois</strong></td>
                                </tr>
                                <tr>
                                  <td><strong>< 100 €</strong></td>
                                  <td>5.00 €</td>
                                  <td>10.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>101 € à 200 €</strong></td>
                                  <td>12.00 €</td>
                                  <td>22.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>201 € à 500 €</strong></td>
                                  <td>27.00 €</td>
                                  <td>44.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>501 € à 1 000 €</strong></td>
                                  <td>45.00 €</td>
                                  <td>79.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>1 001 € à 1 500 €</strong></td>
                                  <td>79.00 €</td>
                                  <td>129.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>1 501 € à 2 000 €</strong></td>
                                  <td>99.00 €</td>
                                  <td>169.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>2 001 € à 3 000 €</strong></td>
                                  <td>129.00 €</td>
                                  <td>229.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>3 001 € à 4 000 €</strong></td>
                                  <td>169.00 €</td>
                                  <td>289.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>4 001 € à 5 000 €</strong></td>
                                  <td>249.00 €</td>
                                  <td>369.00 €</td>
                                </tr>
                                <tr>
                                  <td><strong>4 001 € à 5 000 €</strong></td>
                                  <td>249.00 €</td>
                                  <td>369.00 €</td>
                                </tr>
                              </table>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Kilométrage</div>-->
<!--                            <div class="form__item__input-wrapper">-->
<!--                                <input type="text" v-model="garantieTondeuse.km_reel" name="km_reel" id="km_reel"-->
<!--                                       class="input_n" :class="{input_red_shadow: hasError('km_reel')}"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Date d'effet</div>
                            <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
                                <CustomDatepicker :date.sync="effectiveDateInput" :has-error="hasError('effective_date')"></CustomDatepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form_ttl">Information sur la garantie Truffaut Panne + Casse :</div>
                    </div>

<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">V&eacute;hicule</div>-->
<!--                            <div class="form__item__input-wrapper">-->
<!--                                <select v-model="garantieTondeuse.type_vehicule" name="type_vehicule" id="type_vehicule"-->
<!--                                        :disabled="searchVehicleFilled"-->
<!--                                        class="select_n" :class="{input_red_shadow: hasError('type_vehicule')}">-->
<!--                                    <option value="0">Choisir un type de v&eacute;hicule...</option>-->
<!--                                    <option v-for="item in vehicleTypeOptions" :value="item.value">{{item.name}}</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Garantie</div>-->
<!--                            <div class="form__item__input-wrapper">-->
<!--                                <select v-model="garantieTondeuse.garantie" name="garantie" id="garantie" class="select_n"-->
<!--                                        :class="{input_red_shadow: hasError('garantie')}">-->
<!--                                    <option value="0" selected="selected">Choisissez une garantie</option>-->
<!--                                    <option v-for="item in insuranceTypeOptions" :value="item.value">{{item.name}}</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Dur&eacute;e</div>
                            <div class="form__item__input-wrapper">
                                <select v-model="garantieOutilsJardin.duree" name="duree" id="duree" class="select_n"
                                        :class="{input_red_shadow: hasError('duree')}">
                                    <option value="0">Choisir une dur&eacute;e...</option>
                                    <option v-for="item in durationOprions" :value="item.value">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Assistance ?</div>-->
<!--                            <div class="form__item__input-wrapper form__item__input-wrapper&#45;&#45;checkbox">-->
<!--                                <select v-model="garantieAuto.assure" class="select_n w-100">-->
<!--                                    <option value="0">Non</option>-->
<!--                                    <option value="1">Oui</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12">
                        <div class="form_ttl_first">Informations sur le propri&eacute;taire de l'outil de jardin</div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Civilit&eacute;</div>
                            <div class="form__item__input-wrapper">
                                <select name="civilite" id="civilite" class="select_civ" v-model="garantieOutilsJardin.civilite">
                                    <option value="0">M</option>
                                    <option value="1">Mlle</option>
                                    <option value="2">Mme</option>
                                    <option value="4">Mr et Mme</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <template v-if="garantieOutilsJardin.civilite == 3">
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">Société</div>
                                <div class="form__item__input-wrapper">
                                    <input type="text" v-model="garantieOutilsJardin.name_of_signatory" name="name_of_signatory"
                                           id="name_of_signatory" class="input_n" :class="{input_red_shadow: hasError('name_of_signatory')}"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                          <div class="form__item">
                            <div class="form__item__label form__item__label--required">Nom du signataire</div>
                            <div class="form__item__input-wrapper">
                              <input type="text" v-model="garantieOutilsJardin.nom" name="nom" id="nom" class="input_n"
                                     :class="{input_red_shadow: hasError('nom')}"/>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form__item">
                            <div class="form__item__label form__item__label--required">Pr&eacute;nom du signataire</div>
                            <div class="form__item__input-wrapper">
                              <input type="text" v-model="garantieOutilsJardin.prenom" name="prenom" id="prenom"
                                     class="input_n" :class="{input_red_shadow: hasError('prenom')}"/>
                            </div>
                          </div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="col-12">
                          <div class="form__item">
                            <div class="form__item__label form__item__label--required">Nom</div>
                            <div class="form__item__input-wrapper">
                              <input type="text" v-model="garantieOutilsJardin.nom" name="nom" id="nom" class="input_n"
                                     :class="{input_red_shadow: hasError('nom')}"/>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">Pr&eacute;nom</div>
                                <div class="form__item__input-wrapper">
                                    <input type="text" v-model="garantieOutilsJardin.prenom" name="prenom" id="prenom"
                                           class="input_n" :class="{input_red_shadow: hasError('prenom')}"/>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label">Adresse</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieOutilsJardin.adresse" name="adresse" id="adresse"
                                       class="input_n" :class="{input_red_shadow: hasError('addresse')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label">Code postal</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieOutilsJardin.cp" name="cp" id="cp" maxlength="5" class="input_n"
                                       :class="{input_red_shadow: hasError('cp')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label">Ville</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieOutilsJardin.ville" name="ville" id="ville" class="input_n"
                                       :class="{input_red_shadow: hasError('ville')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label">T&eacute;l&eacute;phone</div>
                            <div class="form__item__input-wrapper" :class="{ 'input-addon': existingCustomerFound || isClientSearching }">
                                <input type="text" v-model="garantieOutilsJardin.tel" @input="searchClient" name="tel" id="tel" maxlength="10" class="input_n"
                                    :class="{input_red_shadow: hasError('tel')}"
                                />
                                <div class="form__item__input-wrapper--loader" v-if="isClientSearching">
                                  <Preloader :wrapper-height="'20px'" :size="'20px'" />
                                </div>
                                <button type="button" @click="fillTheFields" class="form_bt form_confirm_button form__item__submit__button--small-helper" v-if="existingCustomerFound && !isClientSearching">
                                  Compléter
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Email</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieOutilsJardin.email" name="email" id="email" class="input_n"
                                       :class="{input_red_shadow: hasError('email')}" />
                            </div>
                        </div>
                    </div>
                    <!--submit-->
                    <div class="col-12">
                        <div class="form__item justify-content-center mt-3 mb-3">
                            <div class="form__item__submit">
                                <Preloader v-if="isSending"/>
                                <input v-else type='submit' name="Submit" value="VOIR LE DEVIS"
                                       class="form_bt form_confirm_button form__item__submit__button btn btn-block"/>
                            </div>
                        </div>
                    </div>
                </div>
                <ValidationErrors :errorsList="errors"/>
            </form>
        </template>
    </div>
</template>

<script>
    import ValidationErrors from '@/components/Garantie/ValidationErrors';
    import garantieFieldsLists from '../../mixins/garantieFieldsLists';
    import Preloader from '@/components/Preloader';
    import {DEBOUNCE} from "@/mixins/helper";
    import {TheMask} from 'vue-the-mask';
    import CustomDatepicker from '@/components/CustomInputs/CustomDatepicker';
    import {INSURANCE_GARDEN, AUTO_ENGINE, AUTO_TYPE, AUTO_DURATION, GARDENTOOL_TYPE} from "@/constants/insuranceAuto";

    const INITIAL_FIELDS_VALUES = Object.freeze({
        id: '',
        civilite: 0,
        nom: '',
        prenom: '',
        name_of_signatory: '',
        adresse: '',
        cp: '',
        ville: '',
        tel: '',
        email: '',
        jour_permis: new Date().getDate(),          //
        mois_permis: new Date().getMonth() + 1,     // set today date
        annee_permis: new Date().getFullYear(),     //
        type_vehicule: 0,
        garantie: 0,
        duree: 0,
        marque_auto: '',
        marque: '',
        modele_porteur: '',
        cylindree: 0,
        power_kw: 0,
        puis_fisc: '',
        jour_mise_en_circulation: '',
        mois_mise_en_circulation: '',
        annee_mise_en_circulation: '',
        num_serie: '',
        num_facture: '',
        prix: '',
        carburant: 0,
        km_reel: '',
        jour_livraison: 1,
        mois_livraison: 1,
        annee_livraison: new Date().getFullYear(),
        jour_vente: 1,
        mois_vente: 1,
        annee_vente: new Date().getFullYear(),
        jour_prise_effet: '',
        mois_prise_effet: '',
        annee_prise_effet: '',
        assure: 0,
    });

    export default {
        name: 'GarantieOutilsJardin',
        components: {ValidationErrors, Preloader, TheMask, CustomDatepicker},
        mixins: [garantieFieldsLists],
        data() {
            return {
                garantieOutilsJardin: {...INITIAL_FIELDS_VALUES},
                errors: {},
                isEdit: false,
                isVehicleSearching: false,
                isBusy: false,
                searchResult: null,
                searchVehicleResult: null,
                searchVehicleFilled: false,
                isClientSearching: false,
                isSending: false,
                effectiveDateInput: '',
                circulationDateInput: '',
                AUTO_ENGINE,
            }
        },
        computed: {
            existingCustomerFound() {
                return !!this.searchResult;
            },
            existingVehicleFound() {
                return !!this.searchVehicleResult;
            },
            insuranceTypeOptions() {
                return [
                        {name: INSURANCE_GARDEN.TYPE_PANNE.NAME, value: INSURANCE_GARDEN.TYPE_PANNE.ID},
                        {name: INSURANCE_GARDEN.TYPE_CASSE.NAME, value: INSURANCE_GARDEN.TYPE_CASSE.ID},
                        {name: INSURANCE_GARDEN.TYPE_PC.NAME, value: INSURANCE_GARDEN.TYPE_PC.ID},
                    ]
            },
            vehicleTypeOptions(){
                return [
                    {name: GARDENTOOL_TYPE.TONDEUSE.NAME, value: GARDENTOOL_TYPE.TONDEUSE.ID},
                    {name: GARDENTOOL_TYPE.TRONCONNEUSE.NAME, value: GARDENTOOL_TYPE.TRONCONNEUSE.ID},
                    {name: GARDENTOOL_TYPE.TAILLEHAIE.NAME, value: GARDENTOOL_TYPE.TAILLEHAIE.ID},
                    {name: GARDENTOOL_TYPE.DEBROUSAILLEUSE.NAME, value: GARDENTOOL_TYPE.DEBROUSAILLEUSE.ID},
                    {name: GARDENTOOL_TYPE.ELAGUEUSE.NAME, value: GARDENTOOL_TYPE.ELAGUEUSE.ID},
                    {name: GARDENTOOL_TYPE.AUTRES.NAME, value: GARDENTOOL_TYPE.AUTRES.ID},
                ]
            },
            durationOprions() {
                let durationOptions = [
                    {name: AUTO_DURATION.MONTH_12.NAME, value: AUTO_DURATION.MONTH_12.ID},
                    {name: AUTO_DURATION.MONTH_24.NAME, value: AUTO_DURATION.MONTH_24.ID},
                ];

                return durationOptions;
            }
        },
        methods: {
            searchClient: DEBOUNCE(function(val) {

                    if (this.garantieOutilsJardin.tel.length > 2) {
                        let url = 'client/searchOne',
                            data = {
                                tel: this.garantieOutilsJardin.tel
                            };
                        this.isClientSearching = true;
                        this.apiGet(url, data, false)
                            .then(response => {
                                if (response.data.client) {
                                    this.searchResult = response.data.client;
                                }

                                this.isClientSearching = false;
                            })
                            .catch(error => {
                                this.showErrorNotification(error);
                                this.isClientSearching = false;
                            })
                    }
                }, 1000),
            fillTheFields() {
                if (this.searchResult) {
                    this.parseClientInfo(this.searchResult);
                    this.searchResult = null;
                }
            },
            serializeData() {
                return this.garantieOutilsJardin;
            },
            onSubmit(event) {
                this.validateEffectiveDate();
                this.validateCirculationDate();
                this.isSending = true;
                let url = 'garantie/outils-jardin';
                if (this.isEdit && this.garantieOutilsJardin.id) {
                    url = 'garantie/outils-jardin/' + this.garantieOutilsJardin.id + '/edit';
                }

                this.apiPost(url, this.serializeData()).then((response) => {
                    this.isSending = false;
                    this.errors = {};

                    if (response.data.quote && response.data.status == 'success') {
                        if (response.data.calcQuotes)
                            this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
                        this.showSuccessNotification(response.data.message, '');
                        this.$router.push('/garantie-outils-jardin-view/' + response.data.quote.id);

                    }
                }).catch(error => {
                    this.isSending = false;
                    this.errors = error.response.data;

                    if(error.response.data.exception === 'App\\Exceptions\\PriceErrorException') {
                        this.errors.errors = {};
                        this.errors.errors.error = [error.response.data.message];
                    }
                })
            },
            getQuoteInfo() {
                this.isBusy = true;
                let url = 'garantie/' + this.$route.params.id;
                this.apiGet(url)
                    .then(response => {
                        if (response.data.quote) {
                            this.parseQuoteInfo(response.data.quote);
                        }

                        this.isBusy = false;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                        this.$router.push('/');
                    })
            },
            parseClientInfo(client) {
                this.garantieOutilsJardin.civilite = client.civility;
                this.garantieOutilsJardin.nom = client.last_name;
                this.garantieOutilsJardin.prenom = client.first_name;
                this.garantieOutilsJardin.name_of_signatory = client.name_of_signatory;
                this.garantieOutilsJardin.adresse = client.address;
                this.garantieOutilsJardin.cp = client.zip;
                this.garantieOutilsJardin.ville = client.city;
                this.garantieOutilsJardin.tel = client.tel;
                this.garantieOutilsJardin.email = client.email;
                this.garantieOutilsJardin.id_client = client.id;

            },
            parseQuoteInfo(quote) {
                this.garantieOutilsJardin.id = quote.id;
                this.garantieOutilsJardin.num_facture = quote.num_facture;

                if (quote.client && quote.client.id) {
                    this.parseClientInfo(quote.client);
                }

                if (quote.details.date_allowed) {
                    this.garantieOutilsJardin.jour_permis = +quote.details.datesParse.day_allowed;
                    this.garantieOutilsJardin.mois_permis = +quote.details.datesParse.month_allowed;
                    this.garantieOutilsJardin.annee_permis = +quote.details.datesParse.year_allowed;
                }


                this.garantieOutilsJardin.type = quote.details.type_vehicle;
                this.garantieOutilsJardin.garantie = quote.details.garantie;
                this.garantieOutilsJardin.duree = quote.details.duration;
                this.garantieOutilsJardin.assure = quote.details.assistance;
                this.garantieOutilsJardin.marque = quote.details.car_brand;
                this.garantieOutilsJardin.modele_porteur = quote.details.modele_porteur;
                this.garantieOutilsJardin.cylindree = quote.details.cylinder;
                this.garantieOutilsJardin.power_kw = quote.details.power_kw;
                this.garantieOutilsJardin.puis_fisc = quote.details.fiscal_power;
                this.garantieOutilsJardin.immatriculation = quote.details.registration;
                this.garantieOutilsJardin.prix = quote.details.prix;

                this.garantieOutilsJardin.jour_mise_en_circulation = quote.details.day_circulation;
                this.garantieOutilsJardin.mois_mise_en_circulation = quote.details.month_circulation;
                this.garantieOutilsJardin.annee_mise_en_circulation = quote.details.year_circulation;

                this.circulationDateInput = new Date(
                    quote.details.year_circulation,
                    quote.details.month_circulation - 1,
                    quote.details.day_circulation,
                );

                this.garantieOutilsJardin.num_serie = quote.details.serial_number;
                this.garantieOutilsJardin.carburant = quote.details.car_fuel;
                this.garantieOutilsJardin.km_reel = quote.details.km_real;
                this.garantieOutilsJardin.immatriculation_ancien_numero = quote.details.registration_old_number;


                if (quote.details.delivery_date) {
                    this.garantieOutilsJardin.jour_livraison = +quote.details.datesParse.day_delivery;
                    this.garantieOutilsJardin.mois_livraison = +quote.details.datesParse.month_delivery;
                    this.garantieOutilsJardin.annee_livraison = +quote.details.datesParse.year_delivery;
                }

                if (quote.details.sale_date) {
                    this.garantieOutilsJardin.jour_vente = +quote.details.datesParse.day_sale;
                    this.garantieOutilsJardin.mois_vente = +quote.details.datesParse.month_sale;
                    this.garantieOutilsJardin.annee_vente = +quote.details.datesParse.year_sale;
                }

                if (quote.details.effective_date) {
                    let effective_day = quote.details.datesParse.day_effective,
                        effective_month = quote.details.datesParse.month_effective - 1,
                        effective_year = quote.details.datesParse.year_effective;

                    this.garantieOutilsJardin.jour_prise_effet = +effective_day;
                    this.garantieOutilsJardin.mois_prise_effet = +effective_month;
                    this.garantieOutilsJardin.annee_prise_effet = +effective_year;

                    this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
                }
            },
            validateEffectiveDate() {
                if(!this.effectiveDateInput) return false;
                let date = this.moment(this.effectiveDateInput);

                this.garantieOutilsJardin.jour_prise_effet = date.format('D');
                this.garantieOutilsJardin.mois_prise_effet = date.format('M');
                this.garantieOutilsJardin.annee_prise_effet = date.format('YYYY');

                return true;
            },
            resetEffectiveDate() {
                this.garantieOutilsJardin.jour_prise_effet = 1;
                this.garantieOutilsJardin.mois_prise_effet = 1;
                this.garantieOutilsJardin.annee_prise_effet = 1970;
            },
            cleanEffectiveDate() {
                this.garantieOutilsJardin.jour_prise_effet = '';
                this.garantieOutilsJardin.mois_prise_effet = '';
                this.garantieOutilsJardin.annee_prise_effet = '';
            },
            validateCirculationDate() {
                if(!this.circulationDateInput) return false;
                let date = this.moment(this.circulationDateInput);

                this.garantieOutilsJardin.jour_mise_en_circulation = date.format('D');
                this.garantieOutilsJardin.mois_mise_en_circulation = date.format('M');
                this.garantieOutilsJardin.annee_mise_en_circulation = date.format('YYYY');

                return true;
            },
            resetCirculationDate() {
                this.garantieOutilsJardin.jour_mise_en_circulation = '';
                this.garantieOutilsJardin.mois_mise_en_circulation = '';
                this.garantieOutilsJardin.annee_mise_en_circulation = '';
            },
            hasError(field) {
                return !!(this.errors.errors && this.errors.errors[field]);
            },
        },
        beforeRouteLeave(to, from, next) {
            this.garantieOutilsJardin = INITIAL_FIELDS_VALUES;
            next();
        },
        mounted() {
            if (this.$route.params.id) {
                this.getQuoteInfo();
                this.isEdit = true;
                this.searchVehicleFilled = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieOutilsJardin.vue